module.exports = __webpack_public_path__ + "public/SideMenuIcons/contentManagement.svg?68db98db";